/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import requestRawDev from '@/utils/requestRawDev'
import { APICore, APIReportPHP } from '@/utils/servicesApi'
// const qs = require('qs')
export function emptyOutbox(data) {
  return requestRaw({
    url: APICore() + '/zeus/license/empty-outbox',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function emptyInbox(data) {
  return requestRaw({
    url: APICore() + '/zeus/license/empty-inbox',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function generateLicenseKey(data) {
  return requestRaw({
    url: APICore() + '/zeus/license/generate-licensekey',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function getAgentTotal(params) {
  return requestRawDev({
    url: APIReportPHP() + '/zeus/license/agent_total?license_id=' + params.license_id,
    method: 'GET',
  })
}

export function getMessageTotal(params) {
  return requestRawDev({
    url: APIReportPHP() + '/zeus/license/message_total?license_id=' + params.license_id + '&provider=' + params.provider,
    method: 'GET',
  })
}

export function getMessageSuccess(params) {
  return requestRawDev({
    url: APIReportPHP() + '/zeus/license/message_success_total?license_id=' + params.license_id + '&provider=' + params.provider,
    method: 'GET',
  })
}
export function getMessagePending(params) {
  return requestRawDev({
    url: APIReportPHP() + '/zeus/license/message_pending_total?license_id=' + params.license_id + '&provider=' + params.provider,
    method: 'GET',
  })
}

export function getMessageError(params) {
  return requestRawDev({
    url: APIReportPHP() + '/zeus/license/message_error_total?license_id=' + params.license_id + '&provider=' + params.provider,
    method: 'GET',
  })
}

export function updateStored(data) {
  return requestRaw({
    url: APICore() + '/zeus/license/update-stored',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function getLicenseById(id) {
  return requestRaw({
    url: APICore() + '/zeus/license/get-license-by-id?id=' + id,
    method: 'GET',
    // data: data // untuk array data post
  })
}
export function getLicenseList(data) {
  return requestRaw({
    url: APICore() + '/zeus/license/list',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function createValidation(data) {
  return requestRaw({
    url: APICore() + '/zeus/license/create-validation',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function createStored(data) {
  return requestRaw({
    url: APICore() + '/zeus/license/create-stored',
    method: 'POST',
    data: data // untuk array data post
  })
}


// WEBPACK FOOTER //
// ./src/api/license.js